module.exports = __webpack_public_path__ + "static/media/course_03.7b33fde4.jpg";